export const news = {
  newsFeedCreateInputPlaceholder: 'Schrijf een bericht...',
  newsFeedSearchInputPlaceholder: 'Zoeken',
  newsFeedPostOwnerCurtainEditTitle: 'Bericht bewerken',
  newsFeedPostOwnerCurtainDeleteTitle: 'Bericht verwijderen',
  newsFeedEditedPostSavedAlertText: 'Bericht opgeslagen!',
  newsFeedEditedPostDeletedAlertText: 'Bericht verwijderd!',
  newsFeedShareCurtainOptionTitle: 'Link kopiëren',
  newsFeedPostLinkCopiedAlertText: 'Link gekopieerd!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Link kopiëren',
  newsFeedOthersPosLinkCopiedAlertText: 'Link gekopieerd!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Rapporteer inhoud',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Bericht verwijderen',
  newsFeedPostDeletePopupTitle: 'Verwijderen',
  newsFeedPostDeletePopupText: 'Dit bericht verwijderen?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Annuleren',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Bevestigen',
  newsFeedPostDeeletedAlertText: 'Bericht verwijderd!',
  newsPostDetailsHeaderTitle: 'Bericht',
  postFeedPostLikesText: 'Vind-ik-leuks',
  postFeedPostCommentsText: 'Reacties',
  postFeedPostNoLikesText: 'Er zijn nog geen vind-ik-leuks',
  postFeedPostLeaveFirstLikeText: 'Je kunt de eerste zijn om leuk te vinden',
  newsFeedPostDetailsNoCommentsText: 'Er zijn nog geen reacties',
  newsFeedPostDetailsFirstCommentText: 'Je kunt de eerste reactie achterlaten',
  newsFeedPostDetailsShareOptionTitle: 'Link kopiëren',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Link gekopieerd!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Link kopiëren',
  newsFeedPostDetailsCopiedAlertText: 'Link gekopieerd!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Rapporteer inhoud',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Melden',
  newsPostDetailsReportedCurtainText: 'Inhoud gerapporteerd',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Reactie bewerken',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Reactie verwijderen',
  newsPostDetailsEditedCommentSavedAlertText: 'Reactie opgeslagen!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Reactie verwijderen',
  postDetailsOtherUsersCommentDeletadAlertText: 'Reactie verwijderd!',
  postDetailsDeleteCommentPopupTitle: 'Verwijderen',
  postDetailsDeleteCommentPopupText: 'Deze reactie verwijderen?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Annuleren',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Bevestigen',
  postDetailsCommDeletedAlertText: 'Reactie verwijderd!',
  postDetailsCommentUserCurtainOptionTitle: 'Rapporteer reactie',
  newsCreatePostCurtainTitle: 'Nieuw bericht',
  newsCreatePostCurtainBodyPlaceholder: 'Plaats hier uw tekst...',
  newsCreatePostPublishButtonTitle: 'Publiceren',
  newsCreatePostUploadSlallerImageAlertText: 'U kunt niet meer dan {size} MB tegelijk uploaden',
  newsPostSavedAlertText: 'Bericht opgeslagen!',
  newsCreatePostAddLocationCurtainTitle: 'Locatie toevoegen',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Locatienaam',
  newsCreatePostEditLocationCurtainText: 'Locatie bewerken',
  newsDeleteLocation: 'Locatie verwijderen',
  newsDiscardPostPopupTitle: 'Concept',
  newsDiscardPostPopupText: 'Dit concept weggooien?',
  newsDiscardPostPopupCancelButtonTitle: 'Annuleren',
  newsDiscardPostPopupCofirmButtonTitle: 'Bevestigen',
  newsNewPostCreatePollTitle: 'Poll maken',
  newsNewPostCreatePollTitleInputPlaceholder: 'Titel',
  newsNewPostCreatePollOptionInputPlaceholder: 'Optie',
  newsNewPostCreatePollAddButtonTitle: 'Optie toevoegen',
  newsNewPostCreatePollCreateButtonTitle: 'Maken',
  newsCreatePostPollTitleBlankAlertText: 'Titel mag niet leeg zijn!',
  newsCreatePostPollOptionBlankAlertText: 'Optie mag niet leeg zijn!',
  newsCreatePostPollLongTitleAlertText: 'Titel mag maximaal {length} tekens bevatten',
  newsCreatePostPollLongOptionAlertText: 'Optie mag maximaal {length} tekens bevatten',
  newsCreatePostPollEditOptionTitle: 'Poll bewerken',
  newsCreatePostPollRemoveOptionTitle: 'Poll verwijderen',
  newsPostPollInfoVotesText: 'stemmen',
  newsPostPollInfoEditVoteText: 'Stem bewerken',
  newsPostPollFinishPollText: 'Poll beëindigen',
  newsPostPollFinishedPollText: 'Voltooid',
  newsPostPollInProgresslText: 'Bezig',
  newsFinishPollCurtainTitle: 'Poll beëindigen',
  newsFinishPollCurtainText: 'Gebruikers kunnen na het beëindigen van de poll niet meer stemmen.',
  newsFinishPollCurtainCancelButtonTitle: 'Annuleren',
  newsFinishPollCurtainConfirmlButtonTitle: 'Bevestigen',
  newsPollInfoPollVotesCurtainTitle: 'Poll stemmen',
  newsEditPostCurtainTitle: 'Bericht bewerken',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Plaats hier uw tekst...',
  newsEditPostCurtainSaveButtonTitle: 'Opslaan',
  newsEditPostSavedAlertText: 'Bericht opgeslagen!',
  newsError: 'Er is iets misgegaan!',
  newsAt: 'om',
  newsSeeMore: 'Bekijk meer...',
  newsMaxAttachments: 'U heeft het maximale aantal bijlagen overschreden. Maximaal aantal bijlagen is {length}',
  newsReply: 'Antwoorden',
  newsPin: 'Bericht vastpinnen',
  newsUnpin: 'Bericht losmaken'
}
